import { languageConstants } from "../../../../constants/system/language/language.constants";

export function language(state = {}, action) {
  switch (action.type) {
    case languageConstants.GETALL_CODES_REQUEST:
      return {
        loading: true
      };
    case languageConstants.GETALL_CODES_SUCCESS:
      return {
        loading: false,
        codes: action.languageCodes
      };
    case languageConstants.GETALL_CODES_FAILURE:
      return {
        error: action.error
      };
    case languageConstants.GETALL_CODES_BY_EVENT_REQUEST:
      return {
        loading: true
      };
    case languageConstants.GETALL_CODES_BY_EVENT_SUCCESS:
      return {
        loading: false,
        eventCodes: action.languageCodes
      };
    case languageConstants.GETALL_CODES_BY_EVENT_FAILURE:
      return {
        error: action.error
      };

    default:
      return state;
  }
}
